<div class="container">
  <div class="header">
    <div
      *ngIf="requiredPositionIndexes?.length === allPositionsIndexes.length"
      class="medium-dark mapfre-fs-s-r mapfre-fw-300"
    >
      {{ 'PROFILE.SECURITY.SIGNING_KEY.KEY.ALL.TITLE' | translate }}
    </div>
    <div
      *ngIf="requiredPositionIndexes?.length !== allPositionsIndexes.length"
      class="medium-dark mapfre-fs-s-r mapfre-fw-300"
    >
      {{
        'PROFILE.SECURITY.SIGNING_KEY.KEY.PARTIAL.TITLE'
          | translate
            : {
                positions: getParsedPositionsExceptLast(),
                lastPosition:
                  requiredPositionIndexes[requiredPositionIndexes?.length - 1]
              }
      }}
    </div>
    <mat-icon matSuffix>
      <ion-icon
      class="medium-dark"
        [name]="showKey ? 'eye' : 'eye-off'"
        (click)="showKey = !showKey"
      ></ion-icon>
    </mat-icon>
  </div>
  <form [formGroup]="keyInputForm" class="content" autoFocused>
    <div *ngFor="let item of allPositionsIndexes">
      <input
        matInput
        [formControlName]="item"
        class="item"
        maxlength="1"
        [type]="showKey ? 'text' : 'password'"
        (input)="onInput(item)"
      />
      <div class="item-number mapfre-fs-xxs medium-dark">
        {{ item }}
      </div>
    </div>
  </form>
</div>